import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Materials_ds_get_material_by_materialIdService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { materialId: number }): 
  Promise<{ result: { Id?: number, AllocationStrategyId?: number, AllocationStrategyWorkflowId?: string, ControllerTypeId?: number, Description?: string, GlobalMaterialId?: number, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean, LookupCode?: string, MaterialGroupId?: number, MinimumDatingSpan?: number, Name?: string, ProjectId?: number, ScanSerialOfAllPackageLevels?: boolean, Status?: { Id?: number, Name?: string }, MaterialGroup?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_material_by_materialId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { materialId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, AllocationStrategyId?: number, AllocationStrategyWorkflowId?: string, ControllerTypeId?: number, Description?: string, GlobalMaterialId?: number, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean, LookupCode?: string, MaterialGroupId?: number, MinimumDatingSpan?: number, Name?: string, ProjectId?: number, ScanSerialOfAllPackageLevels?: boolean, Status?: { Id?: number, Name?: string }, MaterialGroup?: { Name?: string } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_material_by_materialId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { materialId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, AllocationStrategyId?: number, AllocationStrategyWorkflowId?: string, ControllerTypeId?: number, Description?: string, GlobalMaterialId?: number, IsFixedLength?: boolean, IsFixedVolume?: boolean, IsFixedWeight?: boolean, LookupCode?: string, MaterialGroupId?: number, MinimumDatingSpan?: number, Name?: string, ProjectId?: number, ScanSerialOfAllPackageLevels?: boolean, Status?: { Id?: number, Name?: string }, MaterialGroup?: { Name?: string } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materialId)) {
      missingRequiredInParams.push('\'materialId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/datasources/ds_get_material_by_materialId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      materialId: number    }) {
        if(isNil(inParams.materialId)) {
          return true; 
        }
      return false;
    }
}
